import { isServer } from "solid-js/web";

import { ENV } from "@/enum/system";

export interface SDKConfig {
  enabled: boolean;
  [key: string]: unknown;
}

export interface SDK {
  name: string;
  config: SDKConfig;
  initialize(): Promise<void>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  reportEvent(event: string, data: Record<string, unknown>): any | undefined;
}

export abstract class BaseSDK implements SDK {
  constructor(
    public name: string,
    public config: SDKConfig,
  ) {}

  abstract initialize(): Promise<void>;

  abstract reportEvent(
    event: string,
    data: Record<string, unknown>, // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ): any | undefined;

  protected loadScript(
    src: string,
    attributes: Record<string, string> = {},
  ): Promise<void> {
    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = src;
      script.async = true;

      Object.entries(attributes).forEach(([key, value]) => {
        script.setAttribute(key, value);
      });

      script.onload = () => resolve();
      script.onerror = (error) => reject(error);

      document.head.appendChild(script);
    });
  }
}
